module.exports = __webpack_public_path__ + "static/media/Basal_5530.b016e751.jpg";